import { hnAPI } from '../../constants/api';
import fetchApi from '../../services/fetch';
import { removeWhiteSpace } from '../../utils/utils'
import { get } from 'lodash';
import { track, generateServerResponseError, generateMessageDisplayedSegment } from 'utils/segmenTracker';
import { ACTIVATION, SERVER_RESPONSE_FAILED, MESSAGE_DISPLAYED } from 'constants/segmentEvents'


const scheduleOrderParams = (params) => {
  return {
    input: {
      included: {
        newInstance: {
          attributes: {
            quantity: 1,
            action: "Add"
          },
          included: {
            childBasketItems: [
              {
                attributes: {
                  action: "Add",
                  quantity: 1
                },
                included: {
                  workOrder: {
                    included: {
                      newInstance: {
                        attributes: {
                          individuals: {
                            contactMedia: [
                              {
                                attributes: {
                                  mediumType: "phone",
                                  role: "primary",
                                  medium: {
                                    telephoneNumber: {
                                      number: removeWhiteSpace(`504${params.cliTelephone}`),
                                      numberType: "installation"
                                    }
                                  }
                                }
                              }
                            ]
                          },
                          location: {
                            id: params.coverage.id,
                            comments: params.actComments,
                            dateTime: {
                              start: params.selectedDate.startDateTime,
                              end: params.selectedDate.endDateTime
                            },
                            geolocation: {
                              latitude: `${get(params, 'location[0]', '')}`,
                              longitude: `${get(params, 'location[1]', '')}`
                            },
                            attributes: {
                              street: params.street,
                              neighborhood: params.suburb['description'],
                              city: params.city['MUNICIPIO'],
                              state: params.department['DEPARTAMENTO'],
                              country: "HONDURAS",
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            ]
          }
        }
      }
    }
  }
}


const initialState = {
  dates: {}
};

export const scheduleVisit = {
  state: { ...initialState },
  reducers: {
    updateDate(state, payload) {
      return {
        ...state,
        dates: { ...state.dates, ...payload },
      };
    },
    clearSchedule() {
      return { ...initialState }
    }
  },
  effects: dispatch => {
    return {
      async getTimeSlot({ errorCallback, successCallback, ...params }) {
        dispatch.apiStatus.setProcessing(true);
        fetchApi({
          method: "POST",
          url: hnAPI.timeSlots,
          data: { ...params }
        })
          .then(response => {
            const datesArr = get(response, 'data.OptionalAppointments', []);
            const hasValidAppointments = datesArr.length > 0 && Object.keys(datesArr[0]).length > 0;
            if(hasValidAppointments) {
              this.updateDate(response.data);
              successCallback && successCallback();
            }
            else {
              errorCallback && errorCallback(); 
            }

          })
          .catch(error => {
            track(SERVER_RESPONSE_FAILED, { ...generateServerResponseError(error, ACTIVATION, 'Schedule Visit', hnAPI.timeSlots, 'Get Time Slot API') })
            track(MESSAGE_DISPLAYED, { ...generateMessageDisplayedSegment(error, ACTIVATION, 'Get Time Slot API') })
            errorCallback && errorCallback();
          });
      },
      async createInstallationOrder({ callback, orderId, ...params }) {
        dispatch.apiStatus.setProcessing(true);
        fetchApi({
          method: "POST",
          url: hnAPI.installationOrder.replace('{}', orderId),
          data: {...scheduleOrderParams(params)}
        })
          .then(() => {
            callback && callback()
          })
          .catch(error => {
            track(SERVER_RESPONSE_FAILED, { ...generateServerResponseError(error, ACTIVATION, 'Schedule Visit', hnAPI.installationOrder.replace('{}', orderId), 'Create Installation Order API') })
            track(MESSAGE_DISPLAYED, { ...generateMessageDisplayedSegment(error, ACTIVATION, 'Create Installation Order API') })
            dispatch.apiStatus.setRequestFailed({ ...error });
          });
      },
    };
  }
};